export default __webpack_public_path__ + "static/0015-06530864119d71ba7f608cce92877043.png";